var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "details-view" }, [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "tabs-container" },
          [
            _c(
              "el-tabs",
              {
                staticStyle: { width: "100%" },
                attrs: { type: "card" },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    key: "stayUploadPhotoWarehouse",
                    attrs: {
                      name: "stayUploadPhotoWarehouse",
                      label: _vm.$t("CargoMsg.Cargo_PhotoShootingAwait"),
                      lazy: true
                    }
                  },
                  [_c("stay-upload-photo-warehouse")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: "stayUploadPhotoLoading",
                    attrs: {
                      name: "stayUploadPhotoLoading",
                      label: _vm.$t("CargoMsg.Cargo_PhotoShootingAwaitPallets"),
                      lazy: true
                    }
                  },
                  [_c("stay-upload-photo-loading")],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }